import { request } from "@umijs/max";

/** 获取 Bootstrap 数据 GET /app/bootstrap/pm-web-jp（本前端是 3plusx-pm 项目管理端，菜单读 pm-web-jp） */
export async function getBootstrapData() {
  return request<API.BootstrapData>("/app/bootstrap/pm-web-jp", {
    method: "GET",
  });
}
